
import { inputDescLimit, inputTextLimit } from '../../../helpers/fieldRestriction';
import messages from '../../../locale/jsonMessages';

const validate = (values, props) => {
  const errors = {}
  let colonValidation, questionCount, andCount;
  const activeLanguageCodes = props?.activeLanguageCodes || [];

  colonValidation = (!/^(?!.*:).*$/i.test(values?.buttonLink));
  questionCount = (values?.buttonLink?.match(/\?/g) || []).length;
  andCount = (values?.buttonLink?.match(/\&/g) || []).length;

  if (!values?.buttonLink) {
    errors.buttonLink = messages.required;
  } else if (values?.buttonLink?.trim() == '') {
    errors.buttonLink = messages.required;
  } else if (questionCount >= 1 || andCount >= 1 || colonValidation) {
    errors.buttonLink = messages.invalidPageUrl;
  } else if (values?.buttonLink?.length > inputTextLimit) {
    errors.buttonLink = messages.inputTextLimitError;
  }

  if (values?.dynamicFindYourVehicleBlock) {
    let dynamicFindYourVehicleBlockError = [];
    values.dynamicFindYourVehicleBlock.map((item, index) => {
      const dynamicNameError = {};


      const isLanguageInactive = item?.language && activeLanguageCodes.length > 0
        && !activeLanguageCodes.includes(item.language);

      if (!item?.language || item?.language.toString().trim() === '' || isLanguageInactive) {
        dynamicNameError.language = messages.required;
        dynamicFindYourVehicleBlockError[index] = dynamicNameError;
      }

      if (!item?.heading || item?.heading.toString().trim() === '') {
        dynamicNameError.heading = messages.required;
        dynamicFindYourVehicleBlockError[index] = dynamicNameError;
      } else if (item?.heading?.length > inputTextLimit) {
        dynamicNameError.heading = messages.inputTextLimitError;
        dynamicFindYourVehicleBlockError[index] = dynamicNameError;
      }

      if (!item?.buttonLabel || item?.buttonLabel.toString().trim() === '') {
        dynamicNameError.buttonLabel = messages.required;
        dynamicFindYourVehicleBlockError[index] = dynamicNameError;
      } else if (item?.buttonLabel?.length > inputTextLimit) {
        dynamicNameError.buttonLabel = messages.inputTextLimitError;
        dynamicFindYourVehicleBlockError[index] = dynamicNameError;
      }

      ['content1', 'content2', 'content3'].map((field) => {
        if (!item?.[field] || item?.[field].toString().trim() === '') {
          dynamicNameError[field] = messages.required;
          dynamicFindYourVehicleBlockError[index] = dynamicNameError;
        } else if (item?.[field]?.length > inputDescLimit) {
          dynamicNameError[field] = messages.inputDescLimitError;
          dynamicFindYourVehicleBlockError[index] = dynamicNameError;
        }
      });

      ['content4', 'content5'].map((field) => {
        if (item?.[field] && item?.[field].toString().trim() === '') {
          dynamicNameError[field] = messages.required;
          dynamicFindYourVehicleBlockError[index] = dynamicNameError;
        } else if (item?.[field] && item?.[field]?.length > inputDescLimit) {
          dynamicNameError[field] = messages.inputDescLimitError;
          dynamicFindYourVehicleBlockError[index] = dynamicNameError;
        }
      });
    });
    if (dynamicFindYourVehicleBlockError?.length > 0) errors.dynamicFindYourVehicleBlock = dynamicFindYourVehicleBlockError;
  }

  return errors
}

export default validate;
